export default {
  LOGIN_USER: (state, payload) => {
    state.userId = payload.userId
    state.email = payload.email
    state.active = payload.active
    state.firstAccess = payload.firstAccess

    console.log(state)
  }
}
